import React, { useState } from "react";
import { LoginServices } from "../../services/LoginServices";
import {Alert} from "@mui/material";
import {UserLoginRequest} from "../../models/UserModels";
const LoginPage = () => {
  const [opened, setOpened] = useState(false);
  const [formData, setFormData] = useState(UserLoginRequest);


  function handleInputChange(event) {
    const { name, value } = event.target;

    if (name === "dateOfBirth") {
      let formattedValue = value.replace(/\D/g, '');

      if (formattedValue.length > 2) {
        formattedValue = formattedValue.replace(/^(\d{2})/, '$1/');
      }
      if (formattedValue.length > 5) {
        formattedValue = formattedValue.replace(/^(\d{2})\/(\d{2})/, '$1/$2/');
      }
      if (formattedValue.length >= 10) {
        formattedValue = formattedValue.substring(0, 10);
      }
      setFormData({ ...formData, [name]: formattedValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  }

  function handleLoginSubmit(event) {
    event.preventDefault();
    LoginServices.login(formData).then((response) => {
      if (response === undefined) {
        window.location.href = "/";
      } else {
        handleAlert();
      }
    });
  }

  const handleAlert = () => {
    setOpened(true);
    setTimeout(() => {
      setOpened(false);
    }, 3200);
  }

  return (
    <>
      <div className="flex flex-col justify-between h-screen">
        <div className="flex flex-row h-full">
            <div className="flex flex-col md:w-1/2 bg-emerald-700 h-full"></div>
            <div className="flex flex-col w-full lg:w-1/2 px-12 lg:mx-0 lg:px-48 my-auto">
              <div className="flex flex-col justify-center text-center mb-16">
                <div className="flex uppercase text-4xl mb-4 font-bold text-center justify-center">
                  <h1>ESTUDO <span className="text-green-700">EPIDEMIOLÓGICO </span>
                  </h1>
                </div>
                <div className="flex text-xl text-center justify-center">
                  <h2 className="font-inter">
                    Bem-vindo ao seu painel de resultados.
                  </h2>
                </div>
              </div>
              <form onSubmit={handleLoginSubmit} className="md:px-4">
                <label className="pb-6">Matricula</label>
                <br/>
                <input
                  type="text"
                  name="id"
                  value={formData.id}
                  onChange={handleInputChange}
                  placeholder="000000000000000"
                  className="w-full py-3 px-2 rounded border border-gray-300 mb-4 mt-2"
                />
                <br/>
                <label>Data de Nascimento</label> <br/>
                <div className="relative">
                  <input
                    type="text"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleInputChange}
                    placeholder="DD/MM/YYYY"
                    maxLength={10}
                    className="w-full py-3 px-2 rounded border border-gray-300 mb-4 mt-2"
                  />
                </div>
                <input
                  type="submit"
                  name="submit"
                  value="Entrar"
                  className="w-full py-4 bg-emerald-700 text-white rounded-xl mt-4 uppercase cursor-pointer hover:bg-emerald-900"
                />
              </form>
              {opened && (
                <div className="absolute mx-auto w-9/12 lg:w-1/3 bottom-16">
                <Alert severity="error" className="mt-4 w-full">
                  <div className="absolute flex flex-row justify-between items-center">
                    <span>Erro ao fazer login</span>
                  </div>
                </Alert>
                </div>
              )}
            </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
